import { ComponentChild } from 'preact';
import { useMemo } from 'preact/hooks';
import { Tooltip } from 'components/Tooltip';
import { getRandomId } from 'utils/uid.utils';
import { Container, LabelWrapper, InfoIcon } from './Label.styles';

interface LabelProps {
  label: string;
  className?: string;
  children: ComponentChild;
  htmlFor?: string;
  labelTooltip?: string;
}

const Label = ({
  className = '',
  label = '',
  children,
  htmlFor,
  labelTooltip,
}: LabelProps): JSX.Element => {
  const tooltipId = useMemo(() => getRandomId(), []);

  return (
    <Container data-testid="label-container" className={className}>
      {children}
      {label && (
        <LabelWrapper data-testid="label" htmlFor={htmlFor}>
          {label}
          {labelTooltip && (
            <InfoIcon
              data-testid="info-icon"
              role="img"
              tabIndex={0}
              data-tooltip-id={tooltipId}
            />
          )}
        </LabelWrapper>
      )}
      {labelTooltip && <Tooltip id={tooltipId} content={labelTooltip} />}
    </Container>
  );
};

export default Label;
